import {
  DATA_CONNECTOR_GET_DATA_EDIT_BEGIN,
  DATA_CONNECTOR_GET_DATA_EDIT_SUCCESS,
  DATA_CONNECTOR_GET_DATA_EDIT_FAILURE,
  DATA_CONNECTOR_GET_DATA_EDIT_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function getDataEdit(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_GET_DATA_EDIT_BEGIN,
    });
    const { version, projectId, dbUuid } = args
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/xano/${dbUuid}`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_GET_DATA_EDIT_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_GET_DATA_EDIT_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}


export function dismissGetDataEditError() {
  return {
    type: DATA_CONNECTOR_GET_DATA_EDIT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_GET_DATA_EDIT_BEGIN:
      return {
        ...state,
        getDataEditPending: true,
        getDataEditError: null,
      };

    case DATA_CONNECTOR_GET_DATA_EDIT_SUCCESS:
      return {
        ...state,
        getDataEditPending: false,
        getDataEditError: null,
        getDataEditOne: action.data
      };

    case DATA_CONNECTOR_GET_DATA_EDIT_FAILURE:
      return {
        ...state,
        getDataEditPending: false,
        getDataEditError: action.data.error,
      };

    case DATA_CONNECTOR_GET_DATA_EDIT_DISMISS_ERROR:
      return {
        ...state,
        getDataEditError: null,
      };

    default:
      return state;
  }
}
